/**
 * Prep-only CPT exam study experience (not a Brookbush-issued certification).
 *
 * The exam may be described as NCCA-accredited; the study plan itself must
 * not. The NCCA mark may appear only inside the exam registration card on
 * the study plan page.
 */
export const ACCREDITED_CPT_EXAM_STUDY_PLAN = {
	/** Page H1 / document title — plan name only; no accreditation wording. */
	pageTitle: "CPT Certification Study Plan",
	pageDescription:
		"The study plan organizes courses that cover the content on the exam. Each course you complete also earns credit toward the BI-CPT and SPC certificates.",
	examPortalHref: "/exam-portal",
	practiceExamCardTitle: "Practice Exam",
	practiceExamCardBody:
		"100 questions drawn at random from a larger bank, so it never goes stale, and built to feel like the accredited exam. Following your exam attempt, the Exam Coach will tell you exactly which courses you need to study next.",
	practiceExamCardCta: "Take the Practice Exam →",
	examBlockTitle: "CPT Certification Examination",
	examDisclaimer:
		"This plan prepares you for the Brookbush Institute CPT Certification examination, accredited by the NCCA. Completing it is not required to sit for the examination and does not count toward it.",
	examRegisterLabel: "Register for the exam →",
} as const;
